import { AppGuard } from './app.guard';

export const guards: any[] = [AppGuard];

export { AppGuard };
